import { useEffect } from 'react';
import { useAppDispatch } from '../../../types/redux/state';
import { requestAuthentication } from '../../../actions/authentication';
import { selectIsUserAuthenticated } from '../../../selectors';
import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../../utils/applicationContext';
import { buildNewChatLink } from '../../../utils/chatLink';

/**
 * При переходе по ссылке /new-chat/ для неавторизованного пользователя:
 * - запрашивает авторизацию
 * - после успешной авторизации перезагружает страницу с тем же token для резолва
 */
export const useChatsLinkForUnauthorized = () => {
  const dispatch = useAppDispatch();

  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);

  const {
    custom: { chatsLinkToken },
  } = useApplicationContext();

  useEffect(() => {
    if (!chatsLinkToken || isUserAuthenticated) {
      return;
    }

    dispatch(
      requestAuthentication({
        onSuccess: () => window.location.replace(buildNewChatLink(chatsLinkToken)),
      }),
    );
  }, [chatsLinkToken, isUserAuthenticated, dispatch]);
};
